import * as React from 'react';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {AddressFieldList} from './address-field-list';
import {addressFieldNames} from './consts';

import styles from './multi-line-address-field.module.css';

type Props = {
    control: Control;
    name: string;
    watch: Watch;
    subfields: Array<any>;
};

export function MultiLineAddressField(props: Props) {
    // fields that need to be grouped in the UI
    const addressFields = props.subfields.filter((field) => addressFieldNames.includes(field.name));

    const otherFields = props.subfields.filter((field) => !addressFieldNames.includes(field.name));

    return (
        <>
            <div>
                <AddressFieldList
                    name={props.name}
                    control={props.control}
                    watch={props.watch}
                    fields={otherFields}
                />
            </div>
            <div className={styles['address-fields-grid']}>
                <AddressFieldList
                    name={props.name}
                    control={props.control}
                    watch={props.watch}
                    fields={addressFields}
                />
            </div>
        </>
    );
}
